import { tenantRelations, roleRelations, userRoleRelations, roleResourcePermissionRelations, tenantUserRelations } from './';
export { tenantRelations } from './tenantRelations';
export { roleRelations } from './roleRelations';
export { userRoleRelations } from './userRoleRelations';
export { roleResourcePermissionRelations } from './roleResourcePermissionRelations'; 
export { tenantUserRelations } from './tenantUserRelations';

/**
 * @group User
@summary User domain relations configuration
@remarks
Contains all relationship definitions for the user domain tables.
This includes relationships between users, roles, tenants, and permissions.
@example
```typescript
import { userRelationsConfig } from '@shared/db';
// Use in drizzle config
const db = drizzle(sql, {
  schema: {
    ...userRelationsConfig
  }
});
```
 * @internal
 */
export const userRelationsConfig = {
    tenantRelations,
    roleRelations,
    userRoleRelations,
    roleResourcePermissionRelations,
    tenantUserRelations,
  };
export * from './dataDeletionRequestRelations';
